
import React, {useEffect, useState} from 'react';
import styles from './_client-switcher-drawer.module.scss';
import Drawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PeopleIcon from '@mui/icons-material/People';
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { ListItemButton, TextField } from '@mui/material';
import { isEmpty, includes } from 'ramda';
import { Dealer } from '../../../Models/Dealer';

export interface ClientSwitcherDrawerProps {
  onClose: () => void;
  onSelectClient: (clientId: Dealer) => void;
  isOpen: boolean;
  clients: Dealer[];
  className?: string;
}
export default function ClientSwitcherDrawer (props:  ClientSwitcherDrawerProps) {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filteredClients, setFilteredClients] = useState<Dealer[]>(props.clients);
  useEffect(() => {
    if(isEmpty(searchTerm)){
      setFilteredClients(props.clients)
    } else {
      setFilteredClients(props.clients.filter(c => includes(searchTerm!.toLowerCase(), c.name.toLowerCase())));
    }
  }, [searchTerm, props.clients]);
  return (
      <Drawer anchor={"top"} open={props.isOpen}
        className={props.className}
        onClose={() => {
          props.onClose();
        }}
      >
        <TextField
          label="Search"
          placeholder="search..."
          fullWidth
          margin="none"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          variant="filled"
        />
        <List style={{maxHeight: 'calc(100vh - 90px)', overflowY: 'auto'}}>
          {filteredClients.map((client, key) => (
            <ListItemButton              
              onClick={() => props.onSelectClient(client)}
              key={key}>
              <ListItemIcon>{<PeopleIcon />}</ListItemIcon>
              <ListItemText primary={client.name} />
            </ListItemButton>
          ))}
        </List>
        <Divider />
        <Button onClick={() => props.onClose()}>Close</Button>
      </Drawer>
  );
}
